import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  errors: {},
  filters: {
    loaded: false,
    roles: []
  },
  requesting: null,
  submitting: null,
};

const Slice = createSlice({
  name: '@admin/Accounts|Form',
  initialState,
  reducers: {
    
    
  /**
   * RESET
   */
  initialState: (state) => {
    state.requesting = null;
    state.submitting = null;
    state.errors = {};
    state.user   = {};
  },

  /**
   * GET
   */
  getUser: (state) => {
    state.requesting = true;
    state.user = {};
  },
  getUserSuccess: (state, action) => {
    const { payload } = action;
    state.user = payload;
    state.requesting = false;
  },
  getUserFailed: (state, action) => {
    state.errors = action.errors;
    state.requesting = false;
  },

  // ----- FILTERS ----- 

    getFilters: (state) => {
        state.requesting = true;
    },
    getFiltersSuccess: (state, action) => {
        const { payload } = action;
        state.filters = payload;
        state.filters.loaded = true
    },
    getFiltersFailed: (state, action) => {
        state.errors = action.errors;
        state.requesting = false;
    },


  /**
   * SAVE
   */
  saveForm: (state) => {
        state.errors = {};
        state.submitting = true;
  },
  saveFormSuccess: (state) => {
        state.submitting = false;
  },
  saveFormFailed: (state, action) => {
        state.errors = action.errors;
        state.submitting = null;
  },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminAccountFormReducers: Slice.reducer,
}
export default Reducers;